<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { activeCategoryBrandPage } from '../../brand/store/brand_store';
  import ProductCategoryTile from '../lazy-components/child-helpers/ProductCategoryTile.svelte';

  export let data;
  const dispatcher = createEventDispatcher();

  function onCategoryChange(data) {
    dispatcher('click', data);
  }
</script>

<div class="category-container" class:active={$activeCategoryBrandPage === data.linkName}>
  <ProductCategoryTile
    imageSrc={data.iconUrl}
    categoryName={data.linkName}
    algoliaUrl={data.url}
    carouselRuleName={data.algoliaRuleName}
    on:brandCategoryClicked={e => onCategoryChange(e.detail)}
  />
</div>
